<div class="theme-light" style="height: 100%;" lang="appPageLocale" >
    <div class="app-container">
        <mat-sidenav-container class="app-drawer-container" [ngClass]="{'is-mobile-view': isMobileView}" [dir]="pageDir">
            <mat-sidenav-content>
                <app-navigation-bar (toggleMenuEvent)="toggleMenu($event)" (logoutEvent)="logout()"></app-navigation-bar>
                <div class="content-wrapper" [ngClass]="[isMobileView ? 'is-mobile-view' : '', user ? 'is-logged-in' : '']">
                    @if (!isMobileView && user) {
                        <app-navigation-sidebar class="app-static-sidebarNav"></app-navigation-sidebar>
                    }
                    <main class="app-main-content">
                        <router-outlet></router-outlet>
                    </main>
                </div>
            </mat-sidenav-content>
            <mat-sidenav #siteMenuDrawer [(opened)]="isSidebarOpened" position="start" style="width: 80%;">
                <app-navigation-sidebar (toggleMenuEvent)="toggleMenu($event)"></app-navigation-sidebar>
            </mat-sidenav>
        </mat-sidenav-container>
    </div>
</div>


